import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  MenuItem,
  Typography,
  IconButton,
  Menu,
  TablePagination,
} from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Sheet, ModalClose } from "@mui/joy";
import { useSelector } from "react-redux";
import { useFetch } from "../../hooks";
import { urls } from "../../urls/urls";
import { BASE_URL_TEST } from "../../utils/baseUrl";

export default function AdminPushnotification() {
  const loginToken = useSelector((state) => state.user.logintoken);

  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [notificationType, setNotificationType] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [notifications, setNotifications] = useState([]);

  const {
    data: saveNotificationData,
    error: saveNotificationError,
    fetchData: saveNotificationDataApi,
  } = useFetch(BASE_URL_TEST + urls("sendNotificationByType"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const handleAdd = () => {
    setIsEdit(false);
    setNotificationType("");
    setTitle("");
    setDescription("");
    setOpen(true);
  };

  const notificationMapping = {
    all: {
      app_type: "all",
      type: "all",
    },
    customer: {
      app_type: "userapp",
      type: "customer",
    },
    vendor: {
      app_type: "vendorapp",
      type: "vendor",
    },
    delivery_agent: {
      app_type: "deliveryapp",
      type: "delivery_agent",
    },
  };
  const handleSave = () => {
    if (!notificationType || !title || !description) return;

    if (isEdit) {
      setNotifications((prev) =>
        prev.map((item) =>
          item.notification_id === selectedId
            ? {
                ...item,
                notification_type: notificationType,
                title,
                description,
              }
            : item,
        ),
      );
      setOpen(false);
      return;
    }
    const payload = notificationMapping[notificationType];

    saveNotificationDataApi({
      app_type: payload.app_type,
      type: payload.type,
      title,
      description,
      data: { screen: "orders" },
    });
  };

  useEffect(() => {
    if (saveNotificationError) return;

    if (saveNotificationData?.status === true || saveNotificationData) {
      setNotifications((prev) => [
        {
          notification_id: Date.now(),
          notification_type: notificationType,
          title,
          description,
          user: "Admin",
          created_date: new Date().toLocaleDateString(),
        },
        ...prev,
      ]);
      setOpen(false);
    }
  }, [saveNotificationData, saveNotificationError]);

  const handleEdit = (row) => {
    setSelectedId(row.notification_id);
    setNotificationType(row.notification_type);
    setTitle(row.title);
    setDescription(row.description);
    setIsEdit(true);
    setOpen(true);
    handleMenuClose();
  };

  const handleDelete = (id) => {
    setNotifications((prev) =>
      prev.filter((item) => item.notification_id !== id),
    );
    handleMenuClose();
  };

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const filteredData = notifications.filter(
    (item) =>
      item.title.toLowerCase().includes(search.toLowerCase()) ||
      item.notification_type.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Box sx={{ p: 3, bgcolor: "#fff" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <TextField
          size="small"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ width: "30%" }}
        />

        <Button
          variant="contained"
          startIcon={<AddCircleOutlineIcon />}
          onClick={handleAdd}
          sx={{
            bgcolor: "#00796b",
            "&:hover": { bgcolor: "#005a4f" },
          }}
        >
          Add Notification
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ bgcolor: "#00796b" }}>
            <TableRow>
              <TableCell sx={{ color: "#fff" }}>Notification ID</TableCell>
              <TableCell sx={{ color: "#fff" }}>Type</TableCell>
              <TableCell sx={{ color: "#fff" }}>Title</TableCell>
              <TableCell sx={{ color: "#fff" }}>Description</TableCell>
              <TableCell sx={{ color: "#fff" }}>User</TableCell>
              <TableCell sx={{ color: "#fff" }}>Created Date</TableCell>
              <TableCell sx={{ color: "#fff" }}>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No Notifications Found
                </TableCell>
              </TableRow>
            ) : (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow key={row.notification_id}>
                    <TableCell>{row.notification_id}</TableCell>
                    <TableCell>{row.notification_type}</TableCell>
                    <TableCell>{row.title}</TableCell>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>{row.user}</TableCell>
                    <TableCell>{row.created_date}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={(e) => handleMenuOpen(e, row.notification_id)}
                      >
                        <MoreVert />
                      </IconButton>

                      <Menu
                        anchorEl={anchorEl}
                        open={
                          Boolean(anchorEl) &&
                          selectedId === row.notification_id
                        }
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={() => handleEdit(row)}>
                          Edit
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleDelete(row.notification_id)}
                        >
                          Delete
                        </MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={filteredData.length}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        onPageChange={(e, newPage) => setPage(newPage)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
      />

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Sheet
          sx={{
            width: 500,
            p: 3,
            borderRadius: 2,
            bgcolor: "#fff",
          }}
        >
          <ModalClose onClick={() => setOpen(false)} />

          <Typography variant="h6" textAlign="center" mb={3}>
            {isEdit ? "Edit Notification" : "Add Notification"}
          </Typography>

          <TextField
            select
            fullWidth
            label="Select User"
            size="small"
            value={notificationType}
            onChange={(e) => setNotificationType(e.target.value)}
            sx={{ mb: 2 }}
          >
            <MenuItem value="all">all</MenuItem>
            <MenuItem value="vendor">vendor</MenuItem>
            <MenuItem value="customer">customer</MenuItem>
            <MenuItem value="delivery_agent">delivery_agent</MenuItem>
          </TextField>

          <TextField
            fullWidth
            label="Notification Title"
            size="small"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            multiline
            rows={4}
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={{ mb: 3 }}
          />

          <Button
            fullWidth
            variant="contained"
            onClick={handleSave}
            sx={{
              bgcolor: isEdit ? "#3f51b5" : "#4caf50",
            }}
          >
            {isEdit ? "Update" : "Save"}
          </Button>
        </Sheet>
      </Modal>
    </Box>
  );
}
